import React from "react";
import { isEmbed, isVideo } from "../../types/utils";
import styles from "./DownloadLink.module.css";
import ModalDialog from "./ModalDialog";

type Props = {
  docUrl?: string;
  fileName: string;
  onClose: () => void;
};

const PreviewFileDialog: React.FC<Props> = ({ docUrl, fileName, onClose }) => {
  if (!docUrl) return null;

  const embed = isEmbed(fileName);

  return (
    <ModalDialog full={embed} onClose={onClose} title={fileName}>
      {embed ? (
        <div className={styles.embedDoc}>
          <embed src={docUrl} width="100%" height="100%" />
        </div>
      ) : isVideo(fileName) ? (
        <video src={docUrl} controls style={{ maxWidth: "100%" }} />
      ) : (
        <img src={docUrl} alt={fileName} style={{ maxWidth: "100%" }} />
      )}
    </ModalDialog>
  );
};

export default PreviewFileDialog;
